<template>
    <div>  
        <div class="sidebar-predictions">
        <div class="sidebar-predictions-header">
            <h2 class="ix-sidebar-predictions-title">Injection</h2>
            <button class="ix-sidebar-predictions-btn-close" type="button" @click="closeSideBar">
                <i class="fal fa-times"></i>
            </button>
        </div>
        <div class="mb-4">   
            <label for="searchStudyInput">Etude</label>
            <input type="text" class="form-control form-control" placeholder="Commencer la saisie pour obtenir des suggestions .." id="searchStudyInput" name="searchStudyInput" v-model="searchStudy.designation">
        </div>
        
        <div class="ix-table-box" v-show="(predictions && predictions.length > 0) || (lots && lots.length > 0)">
            <table class="ix-table ix-table-sm">
                <thead>
                    <th class="min"> 
                        <input type="checkbox" v-model="selectAll"  @change="addAllSelectedPredictions"/>
                    </th>
                    <th>Catégorie</th>
                    <th>Ref.</th>
                    <th>Désignation</th>
                    <th>Qté</th>
                    <th class="text-right">Px de revient</th>
                    <th class="text-right">Px de vente</th>
                </thead>
                <tbody v-if="predictions && predictions.length > 0">
                    <tr v-for="(prediction, index) in predictions" :key="index">
                        <td>
                            <input type="checkbox" v-model="prediction.isSelected" @change="addSelectedPrediction(prediction)">
                        </td>
                        <td>
                            <span v-if="!prediction.is_title">
                                {{ getLabelTypePrediction(prediction.type) }}
                            </span>
                        </td>
                        <td>
                            {{prediction.reference}}
                        </td>
                        <td>
                            <span v-html="truncate(prediction.designation, 20)"></span>
                        </td>
                        <td>
                            <span v-if="!prediction.is_title">{{ prediction.quantity }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="!prediction.is_title">{{ currency(prediction.amount) }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="!prediction.is_title">{{ currency(prediction.selling) }}</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-show="lots && lots.length > 0">

                </tbody>
            </table>
        </div>
        </div>
    </div>
</template>

<script>
import { isMarginInBounds } from './marginBounds';

export default {
    name: 'InjectStudy',
    props: ['studyUrl', 'predictionTypes', 'purchaseTypes', 'typeMargin'],
    data() {
        return {
            searchStudy : {
                designation : null,
                id : null
            },
            lots : [],
            predictions: [],
            selectAll: false,
            typePredictions: this.predictionTypes,
            typePurchases : this.purchaseTypes,
            displaySideBar: this.displayBar,
            margin_type: this.typeMargin,
        }
    },
    methods : {
        closeSideBar(){
            $('.sidebar-predictions').css({'display' : 'none'});
        },
        openSideBar(){
            $('.sidebar-predictions').css({'display' : 'inline-block'});
        },
        addSelectedPrediction(prediction){
            if(prediction.isSelected){
                this.$emit('inject-predictions', {
                    'prediction' : prediction,
                });
            } else {
                this.$emit('remove-inject-predictions', {
                    'prediction_id' : prediction.id
                });
            }
    
        },
        addAllSelectedPredictions(){
            if (this.predictions && this.predictions.length > 0) {
                this.predictions.forEach(prediction => {
                    if (prediction) {
                        prediction.isSelected = this.selectAll;
                        this.addSelectedPrediction(prediction);
                    }
                });
            }
        },
        getLabelTypePrediction(value){
            return this.typePredictions.filter(prediction => {
                return prediction.value == value;
            })[0].label;
        },
        compute(index , from){
            // Prévention champs vide
            if (this.study.predictions[index].quantity == '' || this.study.predictions[index].quantity == null) { this.study.predictions[index].quantity = 0 }
            if (this.study.predictions[index].amount == '' || this.study.predictions[index].amount == null) { this.study.predictions[index].amount = 0 }
            if (this.study.predictions[index].total == '' || this.study.predictions[index].total == null) { this.study.predictions[index].total = 0 }
            if (this.study.predictions[index].margin == '' || this.study.predictions[index].margin == null) { this.study.predictions[index].margin = 0 }
            if (this.study.predictions[index].selling == '' || this.study.predictions[index].selling == null) { this.study.predictions[index].selling = 0 }

             if (this.study.predictions[index].is_title) {
                    this.study.predictions[index].type = ''
                    this.study.predictions[index].quantity = 1;
                    this.study.predictions[index].unit = '';
                    this.study.predictions[index].amount = 0;
                    this.study.predictions[index].total = 0;
                    this.study.predictions[index].margin = 0;
                    this.study.predictions[index].selling = 0;
                    this.study.predictions[index].total_selling = 0;
            } else {
                if (from == null || from == 'margin') {
                    this.study.predictions[index].selling = this.computeSelling(index)
                } else if (from == 'selling') {
                    this.study.predictions[index].margin = this.computeMargin(index) 
                }


                this.study.predictions[index].total = parseFloat(this.study.predictions[index].quantity) * parseFloat(this.study.predictions[index].amount)
                this.study.predictions[index].total_selling = parseFloat(this.study.predictions[index].quantity) * parseFloat(this.study.predictions[index].selling)
            } 
        },
        computeSelling: function (index) {
            // Taux hors bornes : prix de vente infini ou négatif, on conserve le prix actuel
            if (!isMarginInBounds(this.marginType, this.study.predictions[index].margin)) {
                return this.study.predictions[index].selling
            }

            if (this.marginType == 2) {
                return this.roundCurrency((parseFloat(this.study.predictions[index].amount)/(100 - parseFloat(this.study.predictions[index].margin))) * 100, 2)
            } else {
                var marginTotal = (parseFloat(this.study.predictions[index].amount) / 100) * parseFloat(this.study.predictions[index].margin)
                return this.roundCurrency((parseFloat(this.study.predictions[index].amount) + marginTotal), 2)
            }
        },
        computeMargin: function (index) {
            var marginDiff = parseFloat(this.study.predictions[index].selling) - parseFloat(this.study.predictions[index].amount)

            if (this.marginType == 2) {
                if (parseFloat(this.study.predictions[index].selling) != 0) {
                    var divider = parseFloat(this.study.predictions[index].selling);
                } else {
                    return 0;
                }
            } else {
                if (parseFloat(this.study.predictions[index].amount) != 0) {
                    var divider = parseFloat(this.study.predictions[index].amount);
                } else {
                    return 0;
                }

            }

            return this.roundCurrency((marginDiff/divider) * 100, 2)
        },
    },
    mounted(){
         $("#searchStudyInput").autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.studyUrl,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_selling: this.currency(item.total_selling)
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var designation = item && item.designation ? ' - ' + item.designation : '';

                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.number} ${designation}</span>
                                       <span class="ml-auto ix-state bordered ${item.color}">${item.state}</span>
                                    </div>
                                    <span class="ml-2 badge badge-secondary">${item.formatted_selling}</span>
                                  `;

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                    }

                },
                select: (e, item) => {
                    if (item.item) {
                        this.selectAll = false;
                        this.openSideBar();
                        // Cas d'une étude simple
                        if(item.item.lines && item.item.lines.length > 0)
                            this.predictions = item.item.lines;
                        if(item.item.lots && item.item.lots.length > 0)
                            this.lots = item.item.lots;  
                        // Cas d'une étude avec des lots    
                        var designation = item.item.designation ?  ' - ' + item.item.designation : '';
                        this.searchStudy.designation = item.item.number + designation; 
                    }
                }
            }).focus(() => {
                $("#searchStudyInput").autocomplete("search", '');
            });
    }
}
</script>